import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { merge, Subject } from 'rxjs';
import { IIcon } from '../../../shared/components/icon/icon.interface';
import { IconSizesEnum } from '../../../shared/components/icon/icons-sizes.enum';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorMessageComponent implements OnInit, OnChanges, OnDestroy {
  @Input() fieldControl: AbstractControl;
  @Input() errorMessage: string;

  private _destroyed: Subject<boolean> = new Subject<boolean>();

  showErrorMessage: boolean;
  errorIcon: IIcon;

  constructor(private _changeDetectorRef: ChangeDetectorRef) {}

  ngOnChanges() {
    this.showErrorMessage =
      !!this.errorMessage &&
      (this.fieldControl
        ? this.fieldControl.dirty && this.fieldControl.invalid
        : true);
  }

  ngOnInit() {
    this.errorIcon = {
      name: 'error',
      size: IconSizesEnum.small,
    };

    if (this.fieldControl) {
      merge(this.fieldControl.statusChanges, this.fieldControl.valueChanges)
        .pipe(takeUntil(this._destroyed))
        .subscribe(() => {
          this.showErrorMessage =
            !!this.errorMessage && this.fieldControl.invalid;

          this._changeDetectorRef.markForCheck();
        });
    }
  }

  ngOnDestroy() {
    this._destroyed.next(true);
    this._destroyed.unsubscribe();
  }
}
